import { Box, Typography } from '@mui/material';
import Iconify from '../iconify';

export default function LayerToggle({ label, sublabel, color, active, onToggle }) {
  return (
    <Box
      onClick={onToggle}
      sx={{
        display: 'flex', alignItems: 'center', gap: 1.5, px: 1.5, py: 1,
        borderRadius: 1, cursor: 'pointer',
        bgcolor: active ? 'action.selected' : 'transparent',
        '&:hover': { bgcolor: 'action.hover' },
        userSelect: 'none',
      }}
    >
      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: active ? color : 'text.disabled', flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ lineHeight: 1.3 }}>{label}</Typography>
        <Typography variant="caption" color="text.secondary">{sublabel}</Typography>
      </Box>
      <Iconify
        icon={active ? 'eva:eye-fill' : 'eva:eye-off-fill'}
        sx={{ color: active ? 'text.secondary' : 'text.disabled', fontSize: 16 }}
      />
    </Box>
  );
}
